import { render } from "./DashBord.vue?vue&type=template&id=89a6ec04"
import script from "./DashBord.vue?vue&type=script&lang=js"
export * from "./DashBord.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__